<div class="container-fluid mt-3 ">
    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Appareils
        </span>
    </div>
    <div class="row border rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Référence du débimêtre</mat-label>
            <input matInput [(ngModel)]="Model.Debitmetre" placeholder="Référence du débimêtre">
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Référence du thermohygroanémomêtre</mat-label>
            <input matInput [(ngModel)]="Model.Thermohygroanemometre" placeholder="Référence du thermohygroanémomêtre">
        </mat-form-field>
    </div>
    <div class="row mt-3">
        <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>